/* eslint-disable no-case-declarations */
import {
  SET_USER_DETAILS, USER_DETAILS_REQUEST_FAILED, SENDING_USER_DETAILS_REQUEST,
} from '../../types/Types';

/** @type { Object } default state */
const defaultState = {
  userDetailsData: '',
  isUserDetailsSending: false,
  userDetailsError: false,
  isUserDetailsSuccess: false,
};

/**
* dispatched the user data to the store
* @param  { Object } state  default state
* @param  { Object } action dispacthed action from middleware
*/
export default function userDetails(state = defaultState, action = {}) {
  switch (action.type) {
    case SET_USER_DETAILS:
      const data = {};
      data.userDetailsData = action.userDetailsData;
      data.isUserDetailsSending = action.isUserDetailsSending;
      data.isUserDetailsSuccess = action.isUserDetailsSuccess;
      data.userDetailsError = action.userDetailsError;
      return { ...state, ...data };

    case SENDING_USER_DETAILS_REQUEST:
      const sendingRequest = {};
      sendingRequest.userDetailsData = action.userDetailsData;
      sendingRequest.isUserDetailsSending = action.isUserDetailsSending;
      sendingRequest.isUserDetailsSuccess = action.isUserDetailsSuccess;
      sendingRequest.userDetailsError = action.userDetailsError;
      return { ...state, ...sendingRequest };

    case USER_DETAILS_REQUEST_FAILED:
      const errors = {};
      errors.userDetailsData = action.userDetailsData;
      errors.isUserDetailsSending = action.isUserDetailsSending;
      errors.isUserDetailsSuccess = action.isUserDetailsSuccess;
      errors.userDetailsError = action.userDetailsError;
      errors.userDetailsMsg = action.userDetailsMsg;
      return { ...state, ...errors };
    default: return state;
  }
}
